module.exports = __webpack_public_path__ + "img/logo.5ac8769e.svg";